import toast from "react-hot-toast";
import customFetch from "../hooks/fetchWrapper";

// Create a new area
export const createBusDriver = async (formBody) => {
  return toast.promise(
    customFetch("insertDriverDetails", {
      method: "POST",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Creating area...",
      success: (data) => `${data.message}`,
      error: "Failed to create area",
    }
  );
};

export const createBulkBusDriver = async (formBody) => {
  return toast.promise(
    customFetch("insertDriverDetailsBulk", {
      method: "POST",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Creating bus drivers...",
      success: (data) => `${data.message}`,
      error: "Failed to create bus drivers",
    }
  );
};

export const deleteBusDriver = async (driverId) => {
  return toast.promise(
    customFetch(`deleteDriverdetails/${driverId}`, {
      method: "DELETE",
    }),
    {
      loading: "Deleting bus driver...",
      success: (data) => `${data.message}`,
      error: "Failed to delete bus driver",
    }
  );
};

export const deleteAllBusDriver = async (driverId) => {
  return toast.promise(
    customFetch(`deleteAllDrivers`, {
      method: "DELETE",
    }),
    {
      loading: "Deleting bus driver...",
      success: (data) => `${data.message}`,
      error: "Failed to delete bus driver",
    }
  );
};

export const updateBusDriver = async (driverData) => {
  console.log("🚀 ~ updateBusDriver ~ driverData:", driverData);

  // Extract the DriverID for the URL path but keep full data for body
  const { DriverID } = driverData;

  return toast.promise(
    customFetch(`editDriverDetails/${DriverID}`, {
      method: "PUT",
      body: JSON.stringify(driverData), // Send complete driver data including DriverID
    }),
    {
      loading: "Updating bus driver...",
      success: (data) => `${data.message}`,
      error: "Failed to update bus driver",
    }
  );
};

export const getDriverDetailData = async () => {
  try {
    const response = await customFetch("driverandroutes", {
      method: "GET",
    });
    return response ? response?.data : []; // Return an empty array if response is not valid
  } catch (error) {
    console.error("Error fetching emirates:", error);
    throw error;
  }
};

export const getDriverDetailDatawithTime = async (driverId, routeId) => {
  try {
    const queryParams = new URLSearchParams({
      driverId: driverId ?? "", // fallback to empty string if null/undefined
      routeId: routeId ?? "",
    }).toString();

    const response = await customFetch(`driverandrouteswithtime?${queryParams}`, {
      method: "GET",
    });

    return response ? response?.data : [];
  } catch (error) {
    console.error("Error fetching driver details with time:", error);
    throw error;
  }
};
